import $ from "jquery";
import React from "react";
import moment from "moment";
import { useEffect } from "react";
import PropTypes from 'prop-types';
import { Input } from "reactstrap";

const DateRangePicker = ({
    id,
    name,
    startDate = moment().subtract(10, "days"),
    endDate = moment(),
    onChangeRange,
}) => {
    useEffect(() => {
        $(`#${id}`).daterangepicker(
            {
                opens: "left",
                startDate: startDate,
                endDate: endDate,
                locale: {
                    cancelLabel: "Cancelar",
                    applyLabel: "Aplicar",
                    format: "YYYY-MM-DD",
                },
            },
            onChangeRange
        );
    }, []);

    return <Input id={id} type="text" name={name ?? id}></Input>;
};

DateRangePicker.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    onChangeRange: PropTypes.func,
}

export default DateRangePicker;
